if(typeof require !== 'undefined'){
    var $ = (typeof window.$ === 'function') ? window.$ : require('jquery');
    if(typeof $.fn.select2 !== 'function') {
        require('select2');
    }
    var select2_lt = require('select2/src/js/select2/i18n/lt');
    var lang = document.documentElement.getAttribute('lang');
    var Sortable = require ('sortablejs/Sortable')
}

class CmsSelect2{
    static init($context = null){
        var inputSelector = "[data-input^='select2']";
        let $inputs = $context ? $context.find(inputSelector) : $(inputSelector);

        $inputs.each(function (index, element) {
            if($(element).data('select2Id')) return;
            $(element).data('select2_instance', new CmsSelect2($(element).data('options'), element))
        });
    }

    /**
     *
     * @param options
     *      dropdownParent - kur ideti dropdown elementa
     *      sortable - ar galima rikiuoti optionus
     *      data_url - dinamiskai uzkraunamu duomenu nuoroda
     *      depends_on - nuo kokiu inputu priklausos, kokias reiksmes uzkrauti per data_url
     *      required_dependencies - privalomos kitu inpputu reiksmes, kad butu kraunami duomenys is data_url
     *      select_first_value_on_reload - jei uzkraunami duomenis per data_url, ar parinkti pirma elementa, jei gaunamas tik vienas rezultatas
     *
     * @param element
     */

    constructor(options, element) {
        this.element = element;
        switch ($(element).data('input')){
            case 'select2':
                this.init_select2(options, element)
                break;
            case 'select2_ajax':
                this.init_select2_ajax(options, element)
                break;
            case 'select2_tags':
                this.init_select2_tags(options, element)
                break;
        }

        /**
         * Hacky fix for a bug in Select2 with jQuery 3.6.0, 3.6.1 new nested-focus "protection"
         * see: https://github.com/select2/select2/issues/5993
         * see: https://github.com/jquery/jquery/issues/4382
         *
         * TODO: Recheck with the select2 GH issue and remove once this is fixed on their side
         */
        $(element).on('select2:open', function(e) {
            let el = document.querySelector(`[aria-controls="select2-${e.target.id}-results"]`)
            if(el){
                el.focus();
            }

        });
    }

    init_select2(options, input){
        var c = {
            language: lang === 'lt' ? select2_lt: null,
            templateSelection: this.formatSelectedDropdown,
        };
        $.extend(c, options);
        if(c.sortable){
            var values = $(input).data('value');
            if(values && Array.isArray(values)){
                for(var k in values.reverse()){
                    var $option = $(input).find("option[value='"+values[k] +"']");

                    $(input).prepend($option);
                }
            }
        }

        if(typeof c.dropdownParent === "string"){
            c.dropdownParent = $(c.dropdownParent)
        }

        $(input).select2(c)
            //isjungiam atidaryma po clear
            .on('select2:unselecting', function() {
                $(this).data('unselecting', true);
            }).on('select2:opening', function(e) {
            if ($(this).data('unselecting')) {
                $(this).removeData('unselecting');
                e.preventDefault();
            }
        })
        ;
        if(c.sortable){
            this.do_sortable(input);
        }
        if(c.data_url){
            this.load_selec2_data(input, c);
        }


        this.initAdding(input)
    }

    init_select2_ajax(options, input){
        var that = this;
        var c = {
            language: lang === 'lt' ? select2_lt: null,
            width: '90%',
            minimumInputLength: 2,
            templateSelection: this.formatSelectedDropdown,
            templateResult: function (repo) {
                return repo.title || repo.text || repo.id;
            },
            ajax: {
                delay: 500,
                dataType: "json",
                data: function(params) {
                    var filters = {
                        q: params.term
                    };

                    if(c.depends_on){
                        $.each(c.depends_on, function (index, fieldId) {
                            filters[fieldId] = that.getDependValue(fieldId);
                        });
                    }

                    return filters
                },
                processResults: function(data, params) {
                    return { results: data };
                }
            },
        };
        $.extend(c, options);
        c.ajax.url = c.url;
        if(c.dataType) {
            c.ajax.dataType = c.dataType;
        }

        if(typeof c.dropdownParent === "string"){
            c.dropdownParent = $(c.dropdownParent)
        }

        $(input).select2(c)
            //isjungiam atidaryma po clear
            .on('select2:unselecting', function() {
                $(this).data('unselecting', true);
            }).on('select2:opening', function(e) {
            if ($(this).data('unselecting')) {
                $(this).removeData('unselecting');
                e.preventDefault();
            }
        });

        if(c.sortable){
            this.do_sortable(input)
        }

        this.initAdding(input)
    }
    init_select2_tags(options, input){
        var that = this;
        var c = {
            language: lang === 'lt' ? select2_lt: null,
            width: '90%',
            tags: true,
            templateSelection: this.formatSelectedDropdown,
        };
        $.extend(c, options);

        if(c.url){
            c.ajax = {
                url: c.url,
                delay: 500,
                dataType: "json",
                data: function(params) {
                    var filters = {
                        q: params.term
                    };

                    if(c.depends_on){
                        $.each(c.depends_on, function (index, fieldId) {
                            filters[fieldId] = that.getDependValue(fieldId);
                        });
                    }

                    return filters
                },
                processResults: function(data, params) {
                    return { results: data };
                }
            };
            c.templateResult = function (repo) {
                return repo.title || repo.text || repo.id;
            };

            if(c.dataType) {
                c.ajax.dataType = c.dataType;
            }
        }

        if(typeof c.dropdownParent === "string"){
            c.dropdownParent = $(c.dropdownParent)
        }

        $(input).select2(c)
            //isjungiam atidaryma po clear
            .on('select2:unselecting', function() {
                $(this).data('unselecting', true);
            }).on('select2:opening', function(e) {
            if ($(this).data('unselecting')) {
                $(this).removeData('unselecting');
                e.preventDefault();
            }
        });
        if(c.sortable){
            this.do_sortable($(input));
        }

        if(c.data_url){
            this.load_selec2_data(input, c);
        }

        $(input).data('inited', true);
    }

    load_selec2_data(input, c) {
        var that = this;
        var $input = $(input);

        var currentValue = $input.val();
        if(!currentValue || (typeof currentValue === 'object' && currentValue.length == 0)){
            currentValue = $input.data('value');
        }

        function getValuesReady(selectedValues){
            if(selectedValues instanceof Array){
                selectedValues = selectedValues.map(function(v) {
                    return v === null ? null : v.toString()
                });
            }else if(selectedValues){
                selectedValues = [selectedValues]
            }else{
                selectedValues = [];
            }

            return selectedValues;
        }

        function reloadData(selectedValues, firstTime){
            selectedValues = getValuesReady(selectedValues);

            var canLoadData = true;
            if(c.required_dependencies){
                $.each(c.required_dependencies, function (index, fieldId) {
                    var v = that.getDependValue(fieldId);//$("#" + fieldId).val();
                    if(v instanceof Array){
                        if(!v.length){
                            canLoadData = false;
                        }
                    }else{
                        if(!v){
                            canLoadData = false;
                        }
                    }
                });
            }

            if(!canLoadData){
                $input
                    .val('')
                    .prop("disabled", true);
                return;
            }

            var filters = {};
            if(c.depends_on){
                $.each(c.depends_on, function (index, fieldId) {
                    filters[fieldId] = that.getDependValue(fieldId);
                });
            }

            $input.prop("disabled", true);
            $.ajax({
                url: c.data_url,
                data: filters
            }).done(function (data) {
                if(!selectedValues.length && $input.data('value')) {
                    selectedValues = getValuesReady($input.data('value'));
                }
                $input.html('<option style="display: none"></option>');
                $.each(data, function(index, value){
                    if(value.children && value.children.length){
                        var $optgroup = $('<optgroup label="' + value.title+ '"></optgroup>');
                        $input.append($optgroup);
                        $.each(value.children, function(c_index, c_value){
                            var selected = selectedValues.toString().split(',').indexOf(c_value.id.toString()) > -1;
                            var option = new Option(c_value.title, c_value.id, false, selected);
                            $optgroup.append(option);
                        });
                    }else{
                        var selected = selectedValues.toString().split(',').indexOf(value.id.toString()) > -1;
                        var option = new Option(value.title, value.id, false, selected);
                        $input.append(option);
                    }
                });
                if (c.select_first_value_on_reload && data.length === 1) {
                    //select first
                    $input.find('option[value]:first').attr('selected','selected');
                }

                if(firstTime && $input.data('select2').options.options.tags){
                    //for tags, create new inputs for non existing values
                    for (var i in selectedValues){
                        var tag = selectedValues[i];
                        if(!$input.find("option[value='" + tag + "']").length){
                            var tagOption = new Option(tag, tag, false, true);
                            $input.append(tagOption);
                        }
                    }
                }

                $input.prop("disabled", false).change();
            })
        }



        reloadData(currentValue, true);

        if(c.depends_on){
            $.each(c.depends_on, function (index, fieldId) {
                $("#" + fieldId).on('change', function () {
                    reloadData(currentValue, false)
                })
            });
        }
        $input.on('change', function (){
            currentValue = $input.val();
        })
    }
    do_sortable(input) {
        let $select = $(input)
        let $ul = $select.next(".select2-container").find('.select2-selection__rendered');
        let sortableInstance = new Sortable($ul[0], {
            animation: 150,
            filter: '.select2-search__field, .select2-search--inline',
            direction: 'vertical',
            onEnd: function (evt){
                $( $ul.find(".select2-selection__choice").get().reverse() ).each(function() {
                    let title = $(this).attr("title");
                    let option = $select.find( "option:contains(" + title + ")" );
                    $select.prepend(option);
                });
            }
        });
    }
    getDependValue(fieldId) {
        var $input = $("#" + fieldId);
        if ($input.find('input[type="radio"]').length) {
            return $input.find('input[type="radio"]:checked').val()
        } else {
            return $input.val()
        }
    }

    initAdding(input, options){
        let that = this
        $(input).closest('.form-group').find('[data-name="add"]').on('click', function () {
            $(document).on('afterLoad.fb', function (event, instance, slide) {
                $(document).off('afterLoad.fb')
                instance.current.$iframe.on('load', function (){
                    $(this).off('load');
                    this.contentWindow.addEventListener('message', function(event) {
                        if(event.data){
                            let newOption = new Option(event.data.title, event.data.id, false, true);
                            $(that.element).append(newOption).trigger('change');
                        }
                    });
                })
            })
        }.bind(this))
    }
    formatSelectedDropdown(state) {
        var title = state.title || state.text || state.id;

        var editLink = $(state.element).parents('select').attr('data-editurl');
        if (editLink === undefined) {
            return title;
        }
        var id = +state.id;
        if (isNaN(id)) {//dėl tags
            return title;
        }
        editLink += (editLink.match(/\?/) ? '&' : '?') + 'id=' + id + '&_display=iframe';

        var $state = $('<span><a href="" target="_blank" data-fancybox="" data-type="iframe"><i class="fa-regular fa-pen-to-square"></i></a> <span></span></span>');
        // Use .text() instead of HTML string concatenation to avoid script injection issues
        $state.find('span').text(title);
        $state.find('a').attr('href', editLink);

        return $state;
    };
}
CmsSelect2.$ = $;
if (typeof module === "object" && typeof module.exports === "object"){

    CmsSelect2.init()
    //node modules support
    module.exports = CmsSelect2;
}else{
    $(function(){
        CmsSelect2.init()
    });
}
